import { useEffect, useState } from 'react';

import { CheckmarkBadge02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';

const AUTO_HIDE_MS = 2500;

export const AutoSavedChip = ({ visible, onHide }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (visible) setIsExiting(false);
  }, [visible]);

  useEffect(() => {
    if (!visible) return;

    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, AUTO_HIDE_MS - 300);

    const hideTimer = setTimeout(() => {
      onHide?.();
      setIsExiting(false);
    }, AUTO_HIDE_MS);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, [visible, onHide]);

  if (!visible) return null;

  return (
    <div
      role="status"
      className={`flex items-center gap-2 text-xl font-regular text-green-2 z-[1000] fixed top-10 right-0 left-0 text-center bg-green-1 border border-green-2 rounded-full px-8 py-2 shadow-xl w-max mx-auto transition-opacity duration-300 ease-out ${isExiting ? 'opacity-0' : 'opacity-100'}`}
      aria-live="polite">
      <HugeiconsIcon icon={CheckmarkBadge02Icon} size="20" className="text-green-2" />
      Your changes have been auto saved.
    </div>
  );
};

export default AutoSavedChip;
